import React, { useMemo, useState } from "react";
import { FeedbackRes } from "../../pages";
import { FeedbackController } from "../../controllers";

const FeedbackResContainer = () => {
  const [loading, setLoading] = useState(false);
  const [feedbackModal, setFeedbackModal] = useState(false);
  const [limit, setLimit] = useState(50);
  const [filterQuery, setFilterQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");

  const feedbackTableQuery = useMemo(() => {
    return `offset=${currentPage + 1}&limit=${limit}`;
  }, [currentPage, limit]);

  const { isLoading, data, isFetching } = FeedbackController.useGetFeedback(
    feedbackTableQuery,
    filterQuery,
    searchQuery
  );

  const onLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(0);
  };

  const closeModal = () => {
    setFeedbackModal(false);
  };

  const filterHandler = async (query) => {
    setLoading(true);
    setFilterQuery(query);
    setLoading(false);
  };
  return (
    <FeedbackRes
      closeModal={closeModal}
      filterHandler={filterHandler}
      feedbackModal={feedbackModal}
      setFeedbackModal={setFeedbackModal}
      isLoading={isLoading}
      feedbackData={data}
      isFetching={isFetching}
      limit={limit}
      onLimitChange={onLimitChange}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      setSearchQuery={setSearchQuery}
      setFilterQuery={setFilterQuery}
      loading={loading}
    />
  );
};
export default FeedbackResContainer;
